import { getSectionVisibleActionType } from '@noths/polaris-client-components';
import { sendGAEvent } from '@noths/polaris-client-google-analytics';
import { EventsMap } from '@noths/polaris-client-next-redux';

import { ReduxApplicationState } from 'src/redux/combinedReducer';
import { actions as trackingActions } from 'src/redux/reviews';
import {
  PRODUCT_REVIEWS_VISIBILITY_NAME,
  ProductReviewsExpandReadMore,
  ProductReviewsImpression,
  ProductReviewsNextPage,
  ProductReviewsPagination,
  ProductReviewsProductRatingSystem,
  ProductReviewsReadReviews,
} from './events';

export const GAEventsMap: EventsMap<ReduxApplicationState> = {
  [getSectionVisibleActionType(PRODUCT_REVIEWS_VISIBILITY_NAME)]: () => {
    sendGAEvent<ProductReviewsImpression>({
      event: 'custom_event',
      event_category: 'Product reviews',
      event_action: 'Impression',
      event_label: 'not set',
    });
  },
  [trackingActions.onProductReviewsExpandReadMore.type]: (_, __, action) => {
    const { payload: isOpen } = action as ReturnType<
      typeof trackingActions.onProductReviewsExpandReadMore
    >;

    if (isOpen) {
      sendGAEvent<ProductReviewsExpandReadMore>({
        event_action: 'Expand review click',
        event_category: 'Product reviews',
        event_label: 'not set',
        event: 'custom_event',
      });
    }
  },
  [trackingActions.onProductReviewsNextPage.type]: (state) => {
    const pageNumber = state.reviews.pagination!.currentPage + 1;

    if (!state.reviews.trackedPageNumberPaginations[pageNumber]) {
      sendGAEvent<ProductReviewsNextPage>({
        event_action: 'Next page click',
        event_category: 'Product reviews',
        event_label: pageNumber,
        event: 'custom_event',
      });
    }
  },
  [trackingActions.onProductReviewsPagination.type]: (_, __, action) => {
    const { payload } = action as ReturnType<typeof trackingActions.onProductReviewsPagination>;

    sendGAEvent<ProductReviewsPagination>({
      event_action: 'Pagination click',
      event_category: 'Product reviews',
      event_label: payload,
      event: 'custom_event',
    });
  },
  [trackingActions.onProductReviewsProductRatingSystem.type]: () => {
    sendGAEvent<ProductReviewsProductRatingSystem>({
      event_action: 'Product rating system click',
      event_category: 'Product reviews',
      event_label: 'not set',
      event: 'custom_event',
    });
  },
  [trackingActions.onProductReviewsReadReviews.type]: () => {
    sendGAEvent<ProductReviewsReadReviews>({
      event_action: 'Read reviews click',
      event_category: 'Product reviews',
      event_label: 'not set',
      event: 'custom_event',
    });
  },
};
